import { WEDDING_TAG } from './EventTagsField';

/**
 * Shared styling for the event chips rendered on both the events-list cell
 * (EventManagement/pages/AllEvents/columns.tsx) and the order-detail event card
 * (OrderDetails/EventDetailFields.tsx). Design contract: Inter semibold
 * 12px/1.25, 6×3px padding, 5px radius. Keeping the shell + colour scheme
 * here means the two surfaces can't drift.
 */
export const EVENT_CHIP_CLASS =
  'inline-flex items-center justify-center rounded-xs border px-2 py-1 font-inter text-xs leading-[1.25] font-semibold whitespace-nowrap shrink-0';

/** border + background + text triplets, verified against the Figma colour review. */
export const CHIP_COLOURS = {
  grey: 'border-grey-light bg-dinnerplate-white-light text-grey',
  wedding: 'border-taro-purple-light bg-taro-purple-lighter text-taro-purple',
  kitchenClosed: 'border-chilli-red-light bg-chilli-blush text-chilli-red',
  securityClearance: 'border-blue-pea-light bg-blue-pea-lighter text-blue-pea',
  preSetup: 'border-cinnamon-brown bg-cinnamon-brown-light text-walnut-brown',
  inHouse: 'border-butter-yellow bg-custard-yellow text-turmeric-yellow',
} as const;

/** Wedding gets the Taro Purple treatment; every other occasion tag renders grey. */
export function tagChipColours(tag: string): string {
  return tag === WEDDING_TAG ? CHIP_COLOURS.wedding : CHIP_COLOURS.grey;
}
